import { Box } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import theme from "src/theme/light"

const useStyles = makeStyles({
  list: {
    lineHeight: '1.5rem',
    color: '#00000099',
    textAlign: 'left',
    paddingLeft: '16px'
  },
  listItem: {
    marginBottom: "5px"
  }
})

export const OrientacoesDimensionado = () => {
  const classes = useStyles()
  
  return (
    <Box>
      <Box p={2}>
        <Box borderRadius="8px" p={2} width='100%' height={"auto"} bgcolor={theme.palette.grey[200]}>
          <Box display="block" width="100%" textAlign={"left"} component="span" fontSize={18} fontWeight={500} color={theme.palette.primary.main}>Orientações de Dimensionamento</Box>
            <ol className={classes.list}>
              <li className={classes.listItem}>O projeto fornece o dimensionamento considerando as cargas prioritárias informadas e a potência desejada em condições normais de uso. No entanto, fatores externos podem comprometer o funcionamento do sistema, como consumo não consciente, aumento de uso durante dias chuvosos, acúmulo de sujeira nos módulos ou instalações incorretas.</li>
              <li className={classes.listItem}>Para projetos com cargas indutivas (exemplo: motor de indução), verifique se a potência e a corrente de partida, não ultrapassam a potência máxima de pico e a corrente suportada pelo inversor recomendado. Em caso de dúvida, consulte o manual dos equipamentos.</li>
              <li className={classes.listItem}>O cálculo realizado para o consumo diário das cargas prioritárias, é calculado com base nas informações preenchidas no campo "Cadastro de cargas prioritárias". Os dados preenchidos neste campo, resultarão na indicação do(s) inversor(es) e bateria(s) apresentados na aba “Solução”.</li>
              <li className={classes.listItem}>A durabilidade da bateria depende de fatores como a temperatura do ambiente de instalação, profundidade de descarga, ciclagem, potências instantâneas e os materiais que compõem a bateria. Em caso de dúvida, consulte o manual da bateria utilizada. O dimensionamento considera uma profundidade de descarga (DoD) de 90% para as baterias.</li>
              <li className={classes.listItem}>A taxa de descarga, expressa em C‑rate, indica quão rápido a bateria entrega sua energia em relação à sua capacidade total.
                  <ul>
                    <li className={classes.listItem}>0,5C: a bateria é descarregada em cerca de 2 horas</li>
                    <li className={classes.listItem}>1C: a bateria é descarregada em cerca de 1 hora</li>
                  </ul>
              </li>
            </ol>
          </Box>
        </Box>
      <Box/>
    </Box>
  );
}